import { render } from "./EditPurchase.vue?vue&type=template&id=434baf40&scoped=true"
import script from "./EditPurchase.vue?vue&type=script&lang=js"
export * from "./EditPurchase.vue?vue&type=script&lang=js"

import "./EditPurchase.vue?vue&type=style&index=0&id=434baf40&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434baf40"]])

export default __exports__